import { render } from "./QuizInitiation.vue?vue&type=template&id=de68fc58&scoped=true&ts=true"
import script from "./QuizInitiation.vue?vue&type=script&lang=ts"
export * from "./QuizInitiation.vue?vue&type=script&lang=ts"

import "./QuizInitiation.vue?vue&type=style&index=0&id=de68fc58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de68fc58"]])

export default __exports__